import React, { useEffect } from "react";
import { Outlet } from "react-router";
import Footer from "./Footer";
import NavBar from "./Navbar";
import AppDownloadPrompt from "./AppDownloadPrompt";
import { useLocation } from "react-router-dom";
import { getLocalToken } from "../../Helper/getToken";

const Layout = () => {
  const location = useLocation();
  const token = getLocalToken();

  return (
    <div className="flex min-h-screen flex-col justify-between items-start">
      {/* {location.pathname === "/login" ? "" : <NavBar />} */}
      <NavBar />
      <AppDownloadPrompt />
      <div className="flex-1 w-full">
        <Outlet />
      </div>

      {location.pathname === "/sign-in" ||
      location.pathname === "/otp-verification" ? (
        <Footer />
      ) : (
        <Footer footerData />
      )}
    </div>
  );
};

export default Layout;
